import styled from 'styled-components'
import { Body, fieldStyles, flatButton } from './shared.styles'
import { black, textMuted, darkGrey, white } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { FieldError } from '@components/Field'
import { ErrorBanner } from '@components/Notice'

/** The step's intro: full card width (no reading-measure cap) and a notch larger than the flow's body copy. */
export const Intro = styled(Body)`
	max-width: none;
	font-size: ${fontSizes.base};
`

export const AddRow = styled.div`
	display: flex;
	gap: 10px;
	margin-top: 16px;
`

/** Restyles the shared places search to the design-system field. */
export const AddField = styled.div`
	flex: 1;
	min-width: 0;

	input {
		${fieldStyles}
		padding-right: 40px;
	}
`

/** The step's cool CTA, on the Button's blue variant. Disabled is the handoff's grey fill, not a fade. */
export const AddButton = styled(Button).attrs({ variant: 'cool' as const })`
	flex-shrink: 0;
	white-space: nowrap;
	height: 44px;

	&:disabled {
		background: ${darkGrey};
		color: ${black};
		opacity: 1;
	}
`

/** The Field primitive's error, sat under the add row like a hint. */
export const AddError = styled(FieldError)`
	display: block;
	margin-top: 8px;
`

export const LimitHint = styled.div`
	margin-top: 8px;
	${text.caption}
	color: ${textMuted};
`

/** The notice above the list when a removed destination still holds events (edit flow). */
export const ListNotice = styled(ErrorBanner)`
	margin-top: 28px;
`

export const DestinationList = styled.ul<{ $afterNotice?: boolean }>`
	list-style: none;
	margin: ${({ $afterNotice }) => ($afterNotice ? '10px' : '28px')} 0 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 10px;
`

export const StepperButton = styled.button`
	${flatButton}
	width: 28px;
	height: 28px;
	border-radius: ${radii.small};
	${text.title}
	line-height: ${leading.none};
	color: ${black};
	user-select: none;

	&:hover:not(:disabled) {
		background: ${white}b3;
	}

	&:disabled {
		opacity: 0.3;
	}
`

export const DayCount = styled.span`
	min-width: 52px;
	text-align: center;
	font-weight: 700;
`

export const PlusButton = styled(StepperButton)`
	margin-right: 8px;
`
